import React, { useMemo } from 'react'
import { Typography } from 'antd'
import cl from 'classnames'

import { Icon } from 'Shared/atoms/index'
import Button from 'Shared/molecules/Button'
import IconButton from 'Shared/molecules/IconButton'

import styles from './styles.module.scss'

const { Text } = Typography

interface DraggerItemProps {
	fileName: string
	onRemove?: () => void
	onDownload: () => void
	isActive?: boolean
	shouldBeDeleted?: boolean
	isRemoveIconVisible?: boolean
	className?: string
	shouldEllipsis?: boolean
}

const SUFFIX_COUNT = 5

const DraggerItem: React.FC<DraggerItemProps> = (props) => {
	const {
		fileName,
		onRemove,
		onDownload,
		isActive = true,
		shouldBeDeleted = false,
		isRemoveIconVisible = true,
		className,
		shouldEllipsis = true
	} = props

	const ellipsisFileName = shouldEllipsis
		? fileName.slice(0, fileName.length - SUFFIX_COUNT).trim()
		: fileName

	const suffix = useMemo(() => {
		if (fileName.length < SUFFIX_COUNT) {
			return ''
		} else {
			return fileName.slice(-SUFFIX_COUNT).trim()
		}
	}, [fileName])

	if (shouldBeDeleted) {
		onRemove && onRemove()
		return null
	}

	if (!isActive) {
		return null
	}

	return (
		<div className={cl(styles.wrapper, className)}>
			<Icon type="attachFile" />
			<Button btnType="link" onClick={onDownload} className={styles.fileButton}>
				<Text
					title={fileName}
					style={{ maxWidth: '100%' }}
					ellipsis={shouldEllipsis ? { suffix } : undefined}
				>
					{ellipsisFileName}
				</Text>
			</Button>
			{isRemoveIconVisible && (
				<IconButton
					size="small"
					type="default"
					shape="circle"
					iconType="close"
					onClick={onRemove}
					className={styles.removeButton}
					iconClassName={styles.removeIcon}
				/>
			)}
		</div>
	)
}

export default DraggerItem
